import * as React from 'react';
import Button from '@mui/material/Button';
import { Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, Stack, TextField, Typography } from '@mui/material';
import { getAccountDeletionRequest, sendDeleteAccountRequest } from '../Api';
import { useNavigate, useParams } from 'react-router-dom';
import AccountDeletionRequestDto from '../models/dtos/AccountDeletionRequestDto';

function isValidEmail(email: string) {
    return /\S+@\S+\.\S+/.test(email);
}

export default function DeleteMyAccountStatusPage() {
    const [state, setState] = React.useState({ isLoading: false, request: { state: "Unknown" } as AccountDeletionRequestDto });
    const code = useParams()['code'] as string

    const navigate = useNavigate();

    React.useEffect(() => {

        const fetchData = async () => {
            setState({ ...state, isLoading: true });
            let request = await getAccountDeletionRequest(code);
            if (request) {
                setState({ ...state, isLoading: false, request: request });
            }
        }

        fetchData();
    }, [])

    const handleDialogClose = () => {
        setState(prevState => ({ ...prevState, dialogOpen: false }));
    }

    return (
        <div>
            <Stack gap="50px 50px" sx={{ mx: 5, my: 5 }} justifyContent='center' alignItems='center'>

                <Grid container spacing={2} columns={{ xs: 1, sm: 2, md: 4 }} alignItems='center'>
                    <Grid item xs={0} sm={0} md={1} />
                    <Grid item xs={2}>
                        <Typography variant="h5">Account deletion request status is {state.request.state}</Typography>
                    </Grid>
                    {state.isLoading ? <React.Fragment></React.Fragment> : <React.Fragment>
                        <Box width="100%" />
                        <Grid item xs={0} sm={0} md={1} />
                        <Grid item xs={2}>
                            <Typography variant="subtitle1">Request was created at: {new Date(state.request.createdAt).toLocaleDateString()}</Typography>
                            <Typography variant="subtitle1">{(state.request.state != "Completed" ? "Request was last time updated at:" : "Request was completed at:") + new Date(state.request.updatedAt).toLocaleDateString()}</Typography>
                        </Grid>
                    </React.Fragment>
                    }
                    {!state.isLoading && state.request.state != "Completed" ? <React.Fragment>
                        <Box width="100%" />
                        <Grid item xs={0} sm={0} md={1} />
                        <Grid item xs={2}>
                            <Typography variant="h6">Your email address for contact:</Typography>
                        </Grid>
                        <Box width="100%" />
                        <Grid item xs={0} sm={0} md={1} />
                        <Grid item xs={2} key="betupId">
                            <TextField disabled type="email" variant="filled" value={state.request.email} fullWidth={true}
                                onChange={e => setState(prevState => ({ ...prevState, email: e.target.value }))} />
                        </Grid>
                        <Box width="100%" />
                        <Grid item xs={0} sm={0} md={1} />
                        <Grid item xs={2}>
                            <Typography sx={{ fontStyle: 'italic' }} variant="h6">Reason (why account deletion request was created):</Typography>
                        </Grid>
                        <Box width="100%" />
                        <Grid item xs={0} sm={0} md={1} />
                        <Grid item xs={2}>
                            <TextField disabled type="email" variant="filled" multiline={true} rows={5} value={state.request.message} fullWidth={true}
                                onChange={e => setState(prevState => ({ ...prevState, message: e.target.value }))} />
                        </Grid>
                        <Grid item xs={2} alignItems='center' container>
                        </Grid>
                        <Box width="100%" />
                        {state.request.state == "Processing" ? <React.Fragment>
                            <Grid item xs={0} sm={0} md={1} />
                            <Grid item xs={2} key="betupId">
                                <Typography variant='body1'>The request for account deletion is being processed. Usually,
                                    it is processed within 48 hours during working days.
                                    After the request is processed, you will no longer be able to access your BETUP account.</Typography>
                            </Grid>
                            <Box width="100%" />
                        </React.Fragment> : <React.Fragment></React.Fragment>}
                    </React.Fragment> : <React.Fragment></React.Fragment>}
                </Grid>
            </Stack >
        </div>
    );
}